/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'home': {
    width: 100,
    height: 100,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M470.2 98.2H78.8c-6.6 0-12 5.4-12 12V628c0 6.6 5.4 12 12 12h391.4c6.6 0 12-5.4 12-12V110.2c0-6.6-5.4-12-12-12zm0 605.7H78.8c-6.6 0-12 5.4-12 12v198.5c0 6.6 5.4 12 12 12h391.4c6.6 0 12-5.4 12-12V715.9c0-6.6-5.4-12-12-12zM945.7 384H554.3c-6.6 0-12 5.4-12 12v517.7c0 6.6 5.4 12 12 12h391.4c6.6 0 12-5.4 12-12V396c0-6.6-5.4-12-12-12zm0-286.1H554.3c-6.6 0-12 5.4-12 12v198.5c0 6.6 5.4 12 12 12h391.4c6.6 0 12-5.4 12-12V109.9c0-6.6-5.4-12-12-12z" _fill="#cdcdcd"/>'
  }
})
